module.exports = __webpack_public_path__ + "img/2.84ac6af8.jpeg";